export const EMBED_OBJECT_TYPES = {
    MSTR_DOSSIER: "dossier",
    PBI_REPORT: "report",
    PBI_DASHBOARD: "dashboard"
}